import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconArrowRight = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7073 6.62622C12.3167 6.2357 11.6836 6.2357 11.2931 6.62622C10.9025 7.01674 10.9025 7.64991 11.2931 8.04043L14.2526 11H7.3335C6.78121 11 6.3335 11.4477 6.3335 12C6.3335 12.5523 6.78121 13 7.3335 13H14.2526L11.2931 15.9596C10.9025 16.3501 10.9025 16.9832 11.2931 17.3738C11.6836 17.7643 12.3167 17.7643 12.7073 17.3738L17.3739 12.7071C17.7645 12.3166 17.7645 11.6834 17.3739 11.2929L12.7073 6.62622Z"
        />
      </svg>
    );
  }
);
